import { useEffect } from "react";
import { useDebouncedCallback } from "use-debounce";
import { Output } from "valibot";

import { ChatDataSchema } from "components/SonicBot/schemas";
import { setSessionStorageValue } from "shared/functions";

import { getPreservedChatDataKey } from "./functions";

function usePreserveChatData(
  instanceName: string,
  token: string,
  chatData: Output<typeof ChatDataSchema>,
  chatId: string,
) {
  const saveChatDataToSessionStorage = useDebouncedCallback(
    () => {
      const preservedChatDataKey = getPreservedChatDataKey(instanceName, token);
      setSessionStorageValue(
        preservedChatDataKey,
        JSON.stringify({
          // chatData,
          chatId,
        }),
      );
    },
    500,
    {
      maxWait: 500,
      leading: true,
    },
  );

  useEffect(() => {
    if (chatId) {
      saveChatDataToSessionStorage();
    }
  }, [saveChatDataToSessionStorage, chatData, chatId]);
}

export default usePreserveChatData;
